var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    [
      _c(
        "el-row",
        { attrs: { gutter: 10, type: "flex", align: "middle" } },
        [
          _c("div", { staticStyle: { "white-space": "nowrap" } }, [
            _vm._v("TCA-ECADUS AWARD APPLICATIONS"),
          ]),
          _vm._v(" "),
          _vm.userLogged
            ? _c("el-col", { attrs: { span: 20 } }, [_c("menubar")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.userLogged
            ? _c(
                "el-col",
                { staticClass: "text-right", attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Log Out")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }